// @core/api/endpoints/userprofile/get_privacy_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetPrivacySettingsResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Get privacy settings for profile
 * Retrieves the profile's privacy configuration including visibility level, who can send messages, and data sharing preferences.
 */
export async function GetPrivacySettings(
  profile_id: string,
  options?: RequestOptions
): Promise<GetPrivacySettingsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/settings/privacy`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.get<GetPrivacySettingsResponse>(requestPath, { ...requestOptions });
}
